<template>
  <div>
    <div id="top" class="jumbotron jumbotron-fluid">
      <div class="container-fluid">
        <!-- <div id="iframe-wrap"> -->
        <iframe
          id="jumbo-iframe"
          v-bind:src="p5src"
          width="10"
          height="10"
          scrolling="no"
        ></iframe>
        <!-- </div> -->
        <h1 id="myName">TAKAYUKI ONO</h1>

        <div id="sketch-more-btn-container">
          <a href="/#/garally">
            <button
              id="sketch-more-btn"
              type="button"
              class="btn btn-outline-secondary btn-lg"
            >
              more >
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const p5Num = 4;
const index = Math.ceil(Math.random() * p5Num);

// --- 開発環境用
// const p5src = 'http://tkyk.net/p5gallery/p' + ('000' + index).slice(-4);
// -----

// --- 本番環境用
const p5src = '../p5gallery/p' + ('000' + index).slice(-4);
// -----

// console.log(p5src);

export default {
  data() {
    return {
      p5src: p5src,
    };
  },
};
</script>

<style>
/* #iframe-wrap {
  height: 60vh;
  min-width: 100%;
  overflow: hidden;
} */
#jumbo-iframe {
  border: none;
  height: 60vh;
  min-width: 100%;

  overflow: hidden;
}

#myName {
  /* position: relative; */
  /* top: 80%; */
  /* transform: translateY(-20%); */
}

#sketch-more-btn-container {
  padding-bottom: 2rem;
}

#sketch-more-btn {
  /* margin: 0 0 0 auto; */
  margin: 0 1rem 0 0;
  float: right;
}
</style>
